import React, { Component } from 'react';
import { Button, Col, Container, Row } from 'reactstrap';
import { site_name } from '../Site';
import { A } from '../routes';

import { T } from '../traks';

const scrollToId = (elem_id) => window.scrollTo(0, document.getElementById(elem_id).offsetTop+55);

function RenderBeginnersGuide(props) {
	const table_of_contents = (
		<React.Fragment>
		{props.guide_entries.map((guide_entry) =>
			<div key={guide_entry.id}>
				<Button className="ad_faq_toc_button text-left pl-0" key={guide_entry.id} onClick={() => scrollToId('guide_entry_' + guide_entry.id)}>
					{guide_entry.q}
				</Button>
			</div>
		)}
		</React.Fragment>
	);
	const q_and_as = (
		<React.Fragment>
		{props.guide_entries.map((guide_entry) =>
			<Row key={"guide_entry_" + guide_entry.id} id={"guide_entry_" + guide_entry.id} className="pb-4">
				<Col xs="12" className="ad_faq_entry">
					<div className="ad_faq_q py-3">
					{guide_entry.q}
					</div>
					<div className="ad_faq_a pb-3">
					{guide_entry.a}
					</div>
				</Col>
			</Row>
		)}
		</React.Fragment>
	)
	return (
		<Row className="pt-3 px-2 px-md-0 ad_pb-25">
		<Col xs="12" md="4" className="pl-md-0 pr-md-5">
			<div className="pb-4">
				<b className="ad_little_larger_text"><T>Table of contents</T></b>
			</div>
			{table_of_contents}
		</Col>
		<Col xs="12" md="8" className="pl-md-5">
			<div className="pb-4">
				<b className="ad_little_larger_text"><T>Investment ABC</T></b>
			</div>
			<div className="pb-4">
				<T>
				Here you can dive into the most important stock exchange terms. If you have questions or
				suggestions regarding the terms, please contact us. We are happy to support you on your
				way to becoming a stock exchange expert. Do you have questions about the game itself?
				Please <A href="/faq">visit our FAQ</A>.
				</T>
			</div>
		{q_and_as}
		</Col>
		</Row>
	);
}

const guide_entries = [
	{ id: 1, q: <T context="guide_q_1"></T>, a: <T context="guide_a_1"></T> },
	{ id: 2, q: <T context="guide_q_2"></T>, a: <T context="guide_a_2" deps={[site_name]}></T> },
	{ id: 3, q: <T context="guide_q_3"></T>, a: <T context="guide_a_3" deps={[site_name]}></T> },
	{ id: 4, q: <T context="guide_q_4"></T>, a: <T context="guide_a_4" deps={[site_name]}></T> },
	{ id: 5, q: <T context="guide_q_5"></T>, a: <T context="guide_a_5" deps={[site_name]}></T> },
	{ id: 6, q: <T context="guide_q_6"></T>, a: <T context="guide_a_6"></T> },
	{ id: 7, q: <T context="guide_q_7"></T>, a: <T context="guide_a_7"></T> },
	{ id: 8, q: <T context="guide_q_8"></T>, a: <T context="guide_a_8"></T> },
	{ id: 9, q: <T context="guide_q_9"></T>, a: <T context="guide_a_9"></T> },
	{ id: 10, q: <T context="guide_q_10"></T>, a: <T context="guide_a_10"></T> },
	{ id: 11, q: <T context="guide_q_11"></T>, a: <T context="guide_a_11"></T> },
	{ id: 12, q: <T context="guide_q_12"></T>, a: <T context="guide_a_12"></T> },
	{ id: 13, q: <T context="guide_q_13"></T>, a: <T context="guide_a_13"></T> },
	{ id: 13, q: <T context="guide_q_14"></T>, a: <T context="guide_a_14"></T> }
];

class BeginnersGuide extends Component {
	render() {
		return (
			<Container className="pt-4 ad_faq_and_guide">
				<RenderBeginnersGuide guide_entries={guide_entries} />
			</Container>
		);
	}
}

export default BeginnersGuide;



// WEBPACK FOOTER //
// ./src/p/BeginnersGuide.js